import React, {useState} from 'react';
import {TaskData} from '../../../../types/TaskData';
import './MaterialReservation.css';
import MaterialReservationTable from "../materialReservationTable/MaterialReservationTable";
import {ViewType} from "../../../../types/ViewType";
import ColorReservationCreation from "../../colorReservation/colorReservationCreation/ColorReservationCreation";
import MeasureOrderCreation from "../../measureOrder/measureOrderCreation/MeasureOrderCreation";

const MaterialReservation: React.FC = () => {
    const [selectedRow, setSelectedRow] = useState<TaskData | null>(null);
    const [refreshKey, setRefreshKey] = useState(0); // Key to trigger table refresh

    const handleRowSelect = (row: TaskData | null) => {
        setSelectedRow(row);
    };

    const onRefreshTable = () => {
        setSelectedRow(null);
        setRefreshKey(prevKey => prevKey + 1);
    };

    return (
        <div className="measure-order-container">
            <div className="table-container-reservation">
                <MaterialReservationTable onSelectRow={handleRowSelect} refreshKey={refreshKey} /> {/* Use updated prop name */}
            </div>
            <div className="detail-container-reservation">
                {selectedRow && (
                    <ColorReservationCreation
                        key={selectedRow.id}
                        data={selectedRow!}
                        onRefreshTable={onRefreshTable}
                        viewType={ViewType.NEW}
                        type="material"></ColorReservationCreation>

                )}
            </div>
        </div>
    );
};

export default MaterialReservation;
